export const TEST_HISTORY_REQUEST = 'TEST_HISTORY_REQUEST';
export const TEST_HISTORY_RESPONSE = 'TEST_HISTORY_RESPONSE';
export const TEST_HISTORY_RESET = 'TEST_HISTORY_RESET';
